import React from "react"
import { GridSortItem } from "@mui/x-data-grid-pro"

import { DataState } from "./state"

type SDT = React.Dispatch<React.SetStateAction<DataState>>

export interface IDataApi {
  setPage: (value: number) => void;
  setPageSize: (value: number) => void;
  setSort: (value: GridSortItem[]) => void;
  reload: () => void
}

export const initApi = (setState_: SDT): IDataApi => {

  const setPageSize: IDataApi["setPageSize"] = (pageSize) => {
    setState_((state) => ({
      ...state,
      pageSize
    }))
  }

  const setPage: IDataApi["setPage"] = (page) => {
    setState_((state) => ({
      ...state,
      page
    }))
  }

  const setSort: IDataApi["setSort"] = (value) => {
    setState_((state) => {
      return {
        ...state,
        sortModel: value
      }
    })
  }

  const reload: IDataApi["reload"] = () => {
    setState_((state) => {
      return {
        ...state,
        reload: state.reload + 1
      }
    })
  }

  return {
    setPage,
    setPageSize,
    setSort,
    reload
  }
}
